<sgt-modal [isOpen]="isOpen" [settings]="modalSettings" (closed)="onClose()">
  <div body class="preferences">
    <nav class="preferences__sidebar">
      <div class="preferences__brand">
        AyA<span class="preferences__brand-suffix"> · ajustes</span>
      </div>

      <div class="preferences__nav">
        <button
          type="button"
          *ngFor="let item of navItems"
          class="preferences__nav-item"
          [class.preferences__nav-item--active]="activeSection === item.section"
          (click)="selectSection(item.section)"
        >
          {{ item.label }}
        </button>
      </div>
    </nav>

    <section #content class="preferences__content" [ngSwitch]="activeSection">
      <button
        type="button"
        class="preferences__close"
        (click)="onClose()"
        aria-label="Fechar"
      >
        <i class="fas fa-times"></i>
      </button>

      <ng-container *ngSwitchCase="sections.Geral">
        <h1 class="preferences__title">Geral</h1>
        <p class="preferences__subtitle">Personalize como a AyA fala com você</p>
        <sgt-general-section *ngIf="isOpen"></sgt-general-section>
      </ng-container>

      <ng-container *ngSwitchCase="sections.Conhecimento">
        <h1 class="preferences__title">Conhecimento da AyA</h1>
        <p class="preferences__subtitle">
          Adicione informações para a AyA conhecer mais sobre você
        </p>
        <sgt-knowledge-section></sgt-knowledge-section>
      </ng-container>

      <ng-container *ngSwitchCase="sections.Memorias">
        <h1 class="preferences__title">Memórias da AyA</h1>
        <p class="preferences__subtitle">Gerencie o que a AyA lembra de você</p>
        <sgt-memories-section></sgt-memories-section>
      </ng-container>

      <ng-container *ngSwitchCase="sections.Habilidades">
        <h1 class="preferences__title">Habilidades da AyA</h1>
        <p class="preferences__subtitle">Gerencie as habilidades da AyA</p>
        <p class="preferences__soon">
          Em breve você poderá consultar tudo o que a AyA sabe fazer.
        </p>
      </ng-container>

      <ng-container *ngSwitchCase="sections.Automacoes">
        <sgt-automations-section></sgt-automations-section>
      </ng-container>

      <ng-container *ngSwitchCase="sections.Conectores">
        <h1 class="preferences__title">Conectores da AyA</h1>
        <p class="preferences__subtitle">Conecte suas ferramentas preferidas com a AyA</p>
        <sgt-connectors-section></sgt-connectors-section>
      </ng-container>

      <ng-container *ngSwitchCase="sections.Plugin">
        <h1 class="preferences__title">Plugin da AyA</h1>
        <p class="preferences__subtitle">Conecte a AyA ao seu provedor de IA preferido</p>
        <sgt-plugin-section></sgt-plugin-section>
      </ng-container>
    </section>
  </div>
</sgt-modal>
